import { ConfirmationSuspendDeactivateIcon, SuspendIcon } from "@/assets";
import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router";

const Reject = () => {
  const [step, setStep] = useState(1);
  return (
    <div className="flex flex-col items-center justify-center gap-10 p-8">
      <div className="flex flex-col gap-9">
        <DialogHeader className="flex flex-col items-center gap-4 text-center text-error-2 ">
          {step == 1 ? <SuspendIcon /> : <ConfirmationSuspendDeactivateIcon />}
          <div className="flex flex-col gap-2">
            <DialogTitle className="text-center">
              {step == 1 ? "Reject User’s KYC?" : "User’s KYC Rejected!"}
            </DialogTitle>
            <DialogDescription className="text-center">
              {step == 1
                ? "Are you sure you want to reject this user’s KYC?"
                : "You have successfully rejected the KYC details of “Opeyemi Ojo”"}
            </DialogDescription>
          </div>
        </DialogHeader>
        {step === 1 && (
          <div className="flex flex-col w-full items-start  gap-1.5 border-[1px]  rounded-[8px] px-2 py-2 h-full border-input-border ">
            <Label htmlFor="message" className="text-xs">
              Reason for Rejection
            </Label>
            <Textarea
              placeholder="Type your message here."
              className="p-0 border-none ring-transparent focus-visible:ring-transparent"
            />
          </div>
        )}
      </div>
      <div className="flex flex-col items-center w-full ">
        {step == 1 ? (
          <>
            <Button
              type="button"
              className="bg-error h-12 rounded-[10px] w-full"
              onClick={() => setStep(2)}
            >
              Yes, I want to approve this KYC <ChevronRight />
            </Button>
            <DialogClose asChild>
              <Button type="button" variant="ghost">
                No, I want to cancel
              </Button>
            </DialogClose>
          </>
        ) : (
          <DialogClose asChild>
            <Link
              to="/dashboard/customers"
              className="flex justify-center items-center bg-off-white-2 h-12 rounded-[10px] w-full text-gray"
            >
              <ChevronLeft /> Back to dashboard
            </Link>
          </DialogClose>
        )}
      </div>
    </div>
  );
};

export default Reject;
